import { Question, Thing } from 'schema-dts';

import { FaqGroup as HygraphFaqGroup } from '@/lib/types';

import FaqGroup from '@/components/faq-group';

import faqGroupTransformer from '@/hygraph/transformers/faq-group.transformer';
import { TSchemaData } from '@/services/schema-service';

export default function FaqGroupRenderer(
  hygraphFaqGroup: HygraphFaqGroup
): JSX.Element | null {
  const faqGroupProps = faqGroupTransformer(hygraphFaqGroup);
  if (!faqGroupProps) return null;

  return <FaqGroup {...faqGroupProps} />;
}

function buildSchema(
  hygraphFaqGroup: HygraphFaqGroup
): Partial<TSchemaData<Thing>> {
  const questions = hygraphFaqGroup.faqs.reduce((output, faq) => {
    if (!faq.content) return output;
    return output.concat({
      '@type': 'Question',
      name: faq.title,
      acceptedAnswer: { '@type': 'Answer', text: faq.content },
    });
  }, [] as Question[]);

  return { questions };
}

FaqGroupRenderer.buildSchema = buildSchema;
